import { render, staticRenderFns } from "./top-chat-ia-pop-up.vue?vue&type=template&id=8fc27b1e&scoped=true&"
import script from "./top-chat-ia-pop-up.vue?vue&type=script&lang=js&"
export * from "./top-chat-ia-pop-up.vue?vue&type=script&lang=js&"
import style0 from "./top-chat-ia-pop-up.vue?vue&type=style&index=0&id=8fc27b1e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc27b1e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fc27b1e')) {
      api.createRecord('8fc27b1e', component.options)
    } else {
      api.reload('8fc27b1e', component.options)
    }
    module.hot.accept("./top-chat-ia-pop-up.vue?vue&type=template&id=8fc27b1e&scoped=true&", function () {
      api.rerender('8fc27b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/top-chat-ia-pop-up/top-chat-ia-pop-up.vue"
export default component.exports